// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/page-actions.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$(),
  _s2 = $RefreshSig$(),
  _s3 = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/page-actions.tsx");
  import.meta.hot.lastModified = "1793811038083.1565";
}
// REMIX HMR END

import { createContext, useCallback, useContext, useState } from 'react';
import { createPortal } from 'react-dom';
const PageActionsContext = createContext({
  container: null,
  register: () => {}
});
export function PageActionsProvider({
  children
}) {
  _s();
  const [container, setContainer] = useState(null);
  const register = useCallback(el => setContainer(el), []);
  return <PageActionsContext.Provider value={{
    container,
    register
  }}>
      {children}
    </PageActionsContext.Provider>;
}
_s(PageActionsProvider, "NIwQDz/goE/Ms54hDNeu56EKUhQ=");
_c = PageActionsProvider;
export function PageActionsSlot({
  className
}) {
  _s2();
  const {
    register
  } = useContext(PageActionsContext);
  return <div ref={register} className={className} />;
}
_s2(PageActionsSlot, "IRfNwUnpmcg++/kxyGT0oGDZqWM=");
_c2 = PageActionsSlot;
export function PageActions({
  children
}) {
  _s3();
  const {
    container
  } = useContext(PageActionsContext);
  if (!container) return null;
  return createPortal(children, container);
}
_s3(PageActions, "jGeSk/KmtHxQPb5hIHLqlB2eEgE=");
_c3 = PageActions;
var _c, _c2, _c3;
$RefreshReg$(_c, "PageActionsProvider");
$RefreshReg$(_c2, "PageActionsSlot");
$RefreshReg$(_c3, "PageActions");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;